import request from '../request/request';
import {handleRes} from '../utils/utils';


interface HandleResInterface {
    success: any,
    fail: any,
}


const getFileUploadUrl = (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
        const res = await request.GETGetFileUploadUrl(params);
        const result = handleRes(res, {
            failMes: res.msg
        });
        if(result && result.success){
          result.success.urlFmt = location.protocol === 'http' ? result.success.url : result.success.surl
        }
        resolve(result);
    });
};

export {
	getFileUploadUrl,
};
